module.exports = __webpack_public_path__ + "static/media/6.bad052ab.jpg";